module.exports = __webpack_public_path__ + "static/media/M51ws.f443a05d.pdf";